import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center align-items-center p-5" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Log ind")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error = _resolveComponent("error")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_error, { error: {
        title: 'Du er blevet logget ud',
        message:
          'Din session er ikke længerne gældende, du kan trykke på knappen nedenunder for at logge ind igen',
      } }),
    _createVNode(_component_Button, {
      class: "primary",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}